import { del, get, post, put } from '@/utils/request'

interface NotiConfigList {
	  feature_set: string
  notification_type_id: number | null
  title_template: string
  event_type: string
  display_type: string
  language: string
  page: number
  page_size: number
}

export function getNotiConfigList<T = any>(data: NotiConfigList) {
  return post<T>({
    url: '/users-service/notifications-template/list',
    data,
  })
}

interface CreateBannerData {
  title_template: string
  image_id: number
  channel: string
  display_type: number
  target_users: string[]
  // user_ids: number[],
  // user_roles: number[],
  // user_segments: number[],
  start_time: number
  end_time: number
  status: number
  notification_category: number
  redirect: string
  event_type: string
  redisplay: string
  feature_set: string
  workspace_ids: number[]

}

interface UpdateBannerData {
  id: number
  title_template: string
  language: string
  image_id: number
  notification_category: string
  channel: string
  target_users: string[]
  event_type: string
  start_time: number
  end_time: number
  feature_set: string
  status: number
  redirect: string
}

interface CreateBellData {
  notification_type_id: number
  messages_template_en: string
  title_template: string
  messages_template_vi: string
  language: string
  image_id: number
  channel: string
  display_type: number
  target_users: string[]
  start_time: number
  end_time: number
  event_type: string
  notification_category: string
  feature_set: string
  banner_id: number
  time_of_sending: number
  group_window: number
  redirect: string
  reminder_offset: number
  schedule_type: string
  workspace_ids: number[]
}

interface UpdateBellData {
  id: number
  notification_type_id: number
  title_template: string
  messages_template_vi: string
  messages_template_en: string
  language: string
  image_id: number
  channel: string
  target_users: string[]
  event_type: string
  start_time: number
  end_time: number
  notification_category: string
  feature_set: string
  status: number
  redirect: string
}

interface NotificationTypeList {
  code: string
  page: number
  page_size: number
}

export function createBanner<T = any>(data: CreateBannerData) {
  return post<T>({
    url: '/users-service/notifications-template/create-banner',
    data,
  })
}

export function updateBanner<T = any>(data: UpdateBannerData) {
  return put<T>({
    url: '/users-service/notifications-template/update-banner',
    data,
  })
}

export function createBell<T = any>(data: CreateBellData) {
  return post<T>({
    url: '/users-service/notifications-template/create-bell',
    data,
  })
}

export function updateBell<T = any>(data: UpdateBellData) {
  return put<T>({
    url: '/users-service/notifications-template/update',
    data,
  })
}

export function getDetailNotificationTemplate<T = any>(id: number) {
  return get<T>({
    url: `/users-service/notifications-template?id=${id}`,
  })
}

export function getNotificationScheduleBannerList<T = any>() {
  return get<T>({
    url: '/users-service/notifications/notification-schedule-banner',
  })
}

export function getUserNotifications<T = any>() {
  return get<T>({
    url: '/users-service/notifications',
  })
}

export function getNotificationDetail<T = any>(id: number) {
  return get<T>({
    url: `/users-service/notifications/get-notification?id=${id}`,
  })
}

export function readUserNotification<T = any>(notificationId: number) {
  return put<T>({
    url: `/users-service/notifications/read/${notificationId}`,
  })
}

export function getUserNotificationsCount<T = any>() {
  return get<T>({
    url: '/users-service/notifications/count',
  })
}

export function deleteBanner<T = any>(id: number) {
  return del<T>({
    url: `/users-service/notifications-template/delete?id=${id}`,
  })
}

export function getNotificationTypeList<T = any>(data: NotificationTypeList) {
  return post<T>({
    url: '/users-service/notifications-type/list',
    data,
  })
}
